import React from "react";
import Services from ".";
import { NewsPage } from "./news.page";
import { NewsProvider } from "./context/news-context";

export function NewsFactory() {

    return (
        <NewsProvider>
            <NewsPage></NewsPage>
        </NewsProvider>
    );
}